var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container password-recovery-page d-flex pa-0"},[_c('div',{staticClass:"left-side"},[_c('change-password-form')],1),_c('div',{staticClass:"right-side d-none d-md-block"},[_c('welcome-block')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }